import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import { createStreetView } from 'utils/search/autocomplete';

export default class StreetView extends PureComponent {
	componentDidMount() {
		const { onLoad, latitude, longitude, pitch, zoom, yaw } = this.props;

		createStreetView(this.instance, {
			latitude,
			longitude,
			pitch,
			zoom,
			yaw,
		}).then(onLoad);
	}

	bindRef = (instance) => {
		this.instance = instance;
	};

	render() {
		return (
			<div
				className="ss-street-view"
				ref={this.bindRef}
			/>
		);
	}
}

StreetView.propTypes = {
	onLoad: PropTypes.func,
	latitude: PropTypes.number,
	longitude: PropTypes.number,
	pitch: PropTypes.number,
	zoom: PropTypes.number,
	yaw: PropTypes.number,
};
StreetView.defaultProps = {
	onLoad: noop,
};
